<app-popover>
  <div app-popover-content class="flex flex-col gap-4">
    <p
      *ngIf="data.typeFilter != 1 && data.auto_matricula"
      class="cursor-pointer hover:text-green-500"
      (click)="passfilterType(1)"
      #popoverBottom
    >
      {{ 'trilhas.relatorio.mais-matriculas' | translate }}
    </p>
    <p
      *ngIf="data.typeFilter != 2 && data.auto_matricula"
      class="cursor-pointer hover:text-green-500"
      (click)="passfilterType(2)"
      #popoverBottom
    >
      {{ 'trilhas.relatorio.menos-matriculas' | translate }}
    </p>
    <p
      *ngIf="data.typeFilter != 3 && !data.auto_matricula"
      class="cursor-pointer hover:text-green-500"
      (click)="passfilterType(3)"
      #popoverBottom
    >
      {{ 'trilhas.relatorio.mais-andamento' | translate }}
    </p>
    <p
      *ngIf="data.typeFilter != 4 && !data.auto_matricula"
      class="cursor-pointer hover:text-green-500"
      (click)="passfilterType(4)"
      #popoverBottom
    >
      {{ 'trilhas.relatorio.menos-andamento' | translate }}
    </p>
    <p
      *ngIf="data.typeFilter != 5"
      class="cursor-pointer hover:text-green-500"
      (click)="passfilterType(5)"
      #popoverBottom
    >
      {{ 'trilhas.relatorio.mais-concluidos' | translate }}
    </p>
    <p
      *ngIf="data.typeFilter != 6"
      class="cursor-pointer hover:text-green-500"
      (click)="passfilterType(6)"
      #popoverBottom
    >
      {{ 'trilhas.relatorio.menos-concluidos' | translate }}
    </p>
  </div>
</app-popover>
